export const getUnsoldQuantity = (quantity, bookedQuantity) => quantity - bookedQuantity
export const getUnsoldValue = (unsoldValue, averageDiscount) => unsoldValue * (1 - averageDiscount)
